import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { LanguageService } from "../services/language/language.service";
import { PATHS, ROUTES } from "src/constants";

@Injectable({
  providedIn: "root",
})
export class LanguageRedirectGuard implements CanActivate {
  constructor(private languageService: LanguageService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const currentLanguage = this.languageService.getCurrentLanguage();
    const url = state.url;
    const path = url.split("/")[1] || "";

    // Check if the URL matches the current language
    const isGermanUrl = this.isGermanPath(path);
    const isEnglishUrl = this.isEnglishPath(path);

    if ((isGermanUrl && currentLanguage === "de") || (isEnglishUrl && currentLanguage === "en")) {
      // URL is consistent with the language, allow navigation
      return of(true);
    } else if (isGermanUrl && currentLanguage === "en") {
      // German URL but English language - switch language to German
      this.languageService.setLanguage("de");
      return of(true);
    } else if (isEnglishUrl && currentLanguage === "de") {
      // English URL but German language - switch language to English
      this.languageService.setLanguage("en");
      return of(true);
    }

    // For URLs that don't have a clear language association, use the current language
    return of(true);
  }

  private isGermanPath(path: string): boolean {
    return (
      path === PATHS[ROUTES.HOME_DE] ||
      path === PATHS[ROUTES.WHAT_DE] ||
      path === PATHS[ROUTES.WORKS_DE] ||
      path === PATHS[ROUTES.NEARSHORING_DE]
    );
  }

  private isEnglishPath(path: string): boolean {
    return (
      path === PATHS[ROUTES.HOME] ||
      path === PATHS[ROUTES.WHAT] ||
      path === PATHS[ROUTES.WORKS] ||
      path === PATHS[ROUTES.NEARSHORING_EN] ||
      path === PATHS[ROUTES.BLOG] ||
      path === PATHS[ROUTES.INCUBATOR]
    );
  }
}
